// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__3LQHu","container":"SectionHeader_container__JjEsT","header__heading":"SectionHeader_header__heading__90JES"};